import React from "react"
import ReactDOM from "react-dom"
import ButtonBlockComponent from "./button-block-component"

export default class ButtonBlockModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ButtonBlockComponent {...self.modelJson} />, self.elem)
  }
}
